import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { HttpLink } from "apollo-link-http";
import {SERVER_LINK} from './config'

const cache = new InMemoryCache();
const link = new HttpLink({
  uri: SERVER_LINK+'/graphql'
});
const client = new ApolloClient({
  cache,
  link
});

export default client;
